const list = [
    {
        projectName: "Gaze NIT-H",
        githubUrl: "https://github.com/spiderxm/orientation-app",
        deploymentUrl: "https://play.google.com/store/apps/details?id=com.silentdevelopers.orientation_app",
        description: "A mobile application that will be like a companion for the freshers to get to know about the college! It will help them to get familiar with the college apart from the stuff we find on the internet, feel the scenic beauty the college offers, different Clubs and societies here, about the campus, places to eat, and many more things. The app is also listing some places to visit; they can plan a trip out there and enjoy after the semester exams are over. The maps in the app will be helpful for them; they'll help in navigation when the paths tend to be strange and new to them.",
        image: "https://play-lh.googleusercontent.com/U7MYty3MdBTEnIm6nhKgXHKU-KvRyCJ-FjUcOYHbhe2y0GqWIpIOdRrPNbza2EMy3qX6=s360-rw",
        type: "mobile"
    },
    {
        projectName: "Paradox 2k21",
        githubUrl: "https://github.com/spiderxm/Paradox2021-FrontEnd",
        deploymentUrl: "https://play.google.com/store/apps/details?id=com.exe.paradox2k21",
        description: "It is an online racking brain game containing levels. The partaker solves the paradox by connecting and recognizing the image or the set of images which will help him/her to reach out the results containing only words in them.\n" +
            "In case the participants are stranded in any riddle, then the hints provided systematically will help them to decrypt the answer. It is a free application and opened to all the partakers across the world.",
        image: "https://play-lh.googleusercontent.com/ysatvrlZzTw6J-ggLVegW5uHUj9dAv8rynJfjsncxldfw0amHQI7nE4Y4GUGKATDTCM=s360-rw",
        type: "mobile"
    },
    {
        projectName: "Trade And Code",
        githubUrl: "https://github.com/spiderxm/TradeAndCode",
        deploymentUrl: null,
        description: "This was an event developed to be held during Nimbus 2k21. The event's focus was to bring an interesting and fun amalgamation of economics and coding. An event based on real-time trading while managing your balance.",
        type: "web",
        image: "https://res.cloudinary.com/dvrvsq95h/image/upload/v1616342694/transparent_logo_ssvk91.png"
    },
    {
        projectName: "Nimbus 2K21",
        githubUrl: "https://github.com/moulikbhardwaj/nimbus2021",
        deploymentUrl: "https://play.google.com/store/apps/details?id=com.silentdevelopers.orientation_app",
        description: "This app is the official app of the technical fest of the college, \"NIMBUS 2k21\". The app enlists details about numerous events, workshops, exhibitions, etc., that will be conducted during the fest. It also presents a schedule for the fest. The app gives details about the talks that will be delivered by leading people in the industry. All the other information related to the fest coordinators, sponsors, etc., are also provided by the application.",
        image: "https://media-exp1.licdn.com/dms/image/C4E0BAQHoaCpPwI3GDA/company-logo_200_200/0/1609401181697?e=1628726400&v=beta&t=z5dBD2VAW6ceYygzS-GVCCQI3WTrL4LKKgzRGeUfTXI",
        type: "mobile"
    },
    {
        projectName: "Sports Registration Platform",
        githubUrl: "https://github.com/spiderxm/sports_app",
        deploymentUrl: "http://ec2-34-232-52-129.compute-1.amazonaws.com/home/",
        description: "Sports Trial Registration Application is a Django Application in which users can register with their information and upload their certificates, keep a check on their achievements and apply for various sports trials based on their sport and state.",
        image: "https://storage.googleapis.com/sport_application/running%205.jpg",
        type: "web"
    },
    {
        projectName: "Machine Learning Algo Visualizer",
        githubUrl: "https://github.com/spiderxm/machine-learning-visualiser",
        deploymentUrl: "https://ml-algo-visualizer.web.app/",
        description: "An Interactive web app built using React Js Which is Deployed With Several Trained Models These Models Are Trained Via Basic Machine Learning Algorithms That Calculates Predictions Based On User Input via API's built using flask",
        image: "https://ml-algo-visualizer.web.app/static/media/machinelearning.cf8c2897.png",
        type: "web"
    },

    {
        projectName: "Financial Dashboard",
        githubUrl: "https://github.com/spiderxm/Financial-Dashboard",
        deploymentUrl: "https://finance-dashboard-1cb4a.web.app/",
        description: "Financial dashboard provides basic stock figures of various corporations. Including candle-stick graphs, bollinger bands, violin plot, histograms, various stock figures such as max, min prices, total volume of stock traded and many more.",
        image: "https://finance-dashboard-1cb4a.web.app/static/media/Financial-chart-economic-graph-analysis-512.81e3ce9a.png",
        type: "web"
    },
    {
        projectName: "Climate app",
        githubUrl: "https://github.com/spiderxm/Weather-application",
        deploymentUrl: "https://play.google.com/store/apps/details?id=com.mrigank.climate",
        description: "Weather application to get full weather details of your location such as current weather maximum and minimum temperature, weekly forecast you can search weather of any city by simply typing out its name.",
        image: "https://play-lh.googleusercontent.com/CL22tCEEK7q-u6C_91TOigc1J_sdsCa7IXf7oqXy4Azq24f9KzlDyFtA8CG-1Cg2Lw=s360-rw",
        type: "mobile"
    },
]


export default list;